<template lang='pug' src='./slider-testimonials.pug'></template>

<script>

export default {
  props: ['props'],
  data () {
    return {
      swiperOption: {
        slidesPerView: 1,
        loop: true,
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        autoplay: {
          delay: 5000
        },
        navigation: {
          prevEl: '.slider-testimonials__prev-arrow',
          nextEl: '.slider-testimonials__next-arrow'
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// slider-testimonials.vue?54af3918